import { Card, Col, Row } from 'antd'
import React from 'react'

const SpicejetFlightContents = () => {
    return (
        <div className='container'>
            <Row gutter={20}>
                <Col md={24}>
                    <Card className='mb-5'>
                        <h2 className='mb-3'>Book SpiceJet Flights at Amazing Prices</h2>
                        <p className='mb-2'>SpiceAirlines is among the most reputable low-cost carriers in India with an excellent reputation of affordability, extensive domestic services, and an expanding international presence. Be it business or recreation, SpiceJet is the best airline to fly with due to its competitive pricing, on time service, and quality in-flight services.</p>
                        <p className='mb-2'>SuperbWorldTrip helps you book SpiceJet air ticket quickly and with ease. You can find the best fares on our site, book instantly and we have convenient booking tools to help organise your trip easily. And to top it all, we also provide a 24x7 customer care service to make your booking experience with SpiceJet Airlines through SuperbWorldTrip even smoother.</p>
                        <p className='mb-4'>Enjoy exclusive deals on SpiceJet flight bookings only with SuperbWorldTrip!!</p>
                        <hr />

                        <h2 className='mb-3 mt-4'>Why Choose SpiceJet Airlines?</h2>
                        <ul className='mb-4'>
                            <li><b>Affordable Travel</b> - SpiceJet Airlines offers cheap airfares making flying affordable and widely accessible..</li>
                            <li><b>On-Time Service</b> - The airline is reputed to be for its on time performance and regularly displays steady performance.</li>
                            <li><b>Good Network</b> -  SpiceJet flies between 60+ cities within India and a number of other international destinations.</li>
                            <li><b>Current Fleet</b> - SpiceJet Airlines has some of the newest and modern aircrafts making air travel safe and convenient.</li>
                            <li><b>Reliable Airline </b> - The airline has also received several recognition as the most reliable low-cost airline in India and their performance speaks for itself..</li>
                        </ul>
                        <hr />

                        <h2 className='mb-3 mt-4'>SpiceJet Fleet & Connectivity</h2>
                        <ul className='mb-4'>
                            <li><b>Aircrafts</b> - SpiceJet has a wide fleet with planes such as Boeing 737, Boeing 737 MAX and noticeably, Bombardier Q400 turboprops used to connect tier 2 and tier 3 cities across India.</li>
                            <li><b>Fleet Size </b> - The airline has more than 100 aircrafts, serving passenger across the country.</li>
                            <li><b>Domestic Reach</b> - It flies approximately to 60 cities across the country connecting all the major metro cities and the tier-2 and tier-3 towns in India.</li>
                            <li><b>International Presence</b> - The international presence of SpiceJet has been on the rise, currently it flies to 13 international destinations. It commonly flies between India and Dubai, Bangkok, Colombo, Jeddah, Male, Muscat, Riyadh, Dhaka, etc.</li>
                            <li><b>Operation Scale</b> - It operates hundreds of flights daily, providing a flexible travelling choice for Indian passengers at low fares.</li>
                        </ul>
                        <hr />

                        <h2 className='mb-3 mt-4'>Popular SpiceJet Flight Booking Routes</h2>
                        <h3 className='mb-2'>Domestic Routes</h3>
                        <table className='mb-3'>
                            <thead>
                                <tr>
                                    <th>Route</th>
                                    <th>Average Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>Delhi to Mumbai</td><td>2 hours</td></tr>
                                <tr><td>Bangalore to Delhi</td><td>2 hours 45 minutes</td></tr>
                                <tr><td>Delhi to Bengaluru</td><td>1 hour 20 minutes</td></tr>
                                <tr><td>Mumbai to Goa</td><td>1 hour 15 minutes</td></tr>
                                <tr><td>Kolkata to Bagdogra</td><td>1 hour 30 minutes</td></tr>
                                <tr><td>Delhi to Jaipur</td><td>1 hour</td></tr>
                            </tbody>
                        </table>

                        <h3 className='mb-2'>Spicejet International Flight Routes</h3>
                        <p className='mb-2'>SpiceJet is continuously increasing its overseas operations. Among the more common International SpiceJet flight destinations are:</p>
                        <ul className='mb-3'>
                            <li>Delhi to Dubai</li>
                            <li>Mumbai to Jeddah</li>
                            <li>Bangalore to Bangkok</li>
                            <li>Chennai to Colombo</li>
                            <li>Kochi to Male</li>
                            <li>Delhi to Muscat</li>
                            <li>Bengaluru to Bangkok</li>
                        </ul>

                        <h3 className='mb-2'>Travel Tips</h3>
                        <ul className='mb-4'>
                            <li>Before traveling internationally, make sure that your passport has a minimum of 6 months of validity.</li>
                            <li>Check visa and transit policies of the destination country to avoid any last-minute surprises.</li>
                            <li>Check in online early to secure your preferred seat.</li>
                            <li>You should regularly monitor weather forecast on your day of travel.</li>
                            <li>Keep an eye on new SpiceJet routes as the airline is expanding globally.</li>
                        </ul>

                        <hr />

                        <h2 className='mb-3 mt-4'>How to Book SpiceJet Flights on SuperbWorldTrip</h2>
                        <p className='mb-2'>You can book your SpiceJet flight at SuperbWorldTrip for a hassle-free experience. Just follow these steps:</p>
                        <ul className='mb-4'>
                            <li>Visit the website - <a href="https://superbworldtrip.com/" target="_blank" rel="noopener noreferrer">https://superbworldtrip.com/</a></li>
                            <li>Entert your cities of departure and destination.</li>
                            <li>Choose your travel dates.</li>
                            <li>Choose the SpiceJet flight booking filter to view only the SpiceJet.</li>
                            <li>Compare price and timing of flights to choose the best option according to your needs.</li>
                            <li>Confirm your choice and enter passenger details.</li>
                            <li>Make the payment using one of the many options available at SuperbWorldTrip.</li>
                            <li>Get your e-ticket in real time.</li>
                        </ul>

                        <hr />

                        <h2 className='mb-3 mt-4'>Baggage Policy of SpiceJet Airlines</h2>
                        <h3>Cabin Baggage</h3>
                        <ul className='mb-3'>
                            <li>Allowance - SpiceJet allows 1 cabin bag up to 7kg + 1 personal item (laptop, handbag, etc.)</li>
                            <li>Dimension -115cm (L+W+H) max</li>
                        </ul>
                        <h3>Checked Baggage</h3>
                        <ul className='mb-3'>
                            <li>Domestic - Standard 15kg allowance.</li>
                            <li>International - Between 20kg and 30kg depending on route/class.</li>
                            <li>Infants - One stroller/baby carriage allowed free of charge. No checked baggage included for infants</li>
                        </ul>

                         <h3>Sports & Special Equipment</h3>
                        <ul className='mb-3'>
                            <li>Sports equipment and oversized luggage can be carried but additional charges need to be paid, as applicable.</li>
                        </ul>

                        <h3>Extra Baggage Charges</h3>
                        <ul className='mb-3'>
                            <li>Passengers can pre-book extra baggage online at discounted rates for 5kg, 10kg, 15kg+ slabs.</li>
                            <li>At the airport, charges are approx. ₹550 - ₹600 per kg.</li>
                        </ul>
                        <p className='mb-4'><b>Tip</b>:  Always pre-book extra luggage online to save costs.</p>

                        <hr />

                        <h2 className='mb-3 mt-4'>SpiceJet Web Check-in & Verification</h2>
                        <p>Check-in Window becomes available 24 - 48 hours before the time of departure. Passengers travelling with SpiceJet can follows these steps for a hassle-free online check-in:</p>
                        <ul className='mb-3'>
                            <li>Visit website/app</li>
                            <li>Enter PNR details</li>
                            <li>Select seats</li>
                            <li>Download boarding pass.</li>
                        </ul>
                        <h4><b>Documents Required:</b></h4>
                        <ul className='mb-3'>
                            <li>For domestic travel, passengers can use any of the valid photo identity cards such as an Aadhaar Card, Driving License, PAN Card, Voter ID, etc.</li>
                            <li>The original Passport with a valid visa is necessary to travel internationally.</li>
                        </ul>

                        <h3 className='mb-2'>SpiceJet Cancellation & Refund Policy</h3>
                        <p>SpiceJet offers flexible cancellation and modification options.</p>
                        <ul className='mb-3'>
                            <li><b>Cancellations</b> -  Reduced cancellation fees if cancelled 3-5 days before the departure. Cancellations and changes made in the booking close to the date of travel could incur a higher fee.</li>
                            <li><b>Refunds</b> - Returned to the original mode of payment in 7-10 working days</li>
                            <li><b>Cancellation </b> - Passengers can cancel their booking through the SpiceJet website/application, SuperbWorldTrip portal, or customer service.</li>
                        </ul>

                        <h3>Why Book SpiceJet Flights with SuperbWorldTrip?</h3>
                        <ul className='mb-4'>
                            <li>Lowest fares are assured on SpiceJet ticket booking with SuperbWorldTrip.</li>
                            <li>Several safe methods of payment (UPI, Cards, Wallets, Net Banking)</li>
                            <li>24/7 customer care service is available to help tackle any issues that may arise.</li>
                            <li>Instant booking confirmation & e-tickets</li>
                            <li>Promo codes, cashback and exclusive offers.</li>
                            <li>100% cashback on flight bookings using SuperbWorldTrip </li>
                        </ul>

                        <hr />

                        <h2 className='mb-3 mt-4'>Frequently Asked Questions </h2>
                        <ol>
                            <li><b>Can I cancel my SpiceJet air ticket online?</b><br />Yes, by using the website/app or SuperbWorldTrip portal, you can easily cancel your reservation online without any hassle.</li>
                            <li><b>Does SpiceJet provide in-flight meals?</b><br />Yes, SpiceJet airlines offers pre-booked and on-board meals. There are also numerous vegetarian and non-vegetarian snacks, meals and drinks available for the passengers.</li>
                            <li><b>What is the baggage allowance for SpiceJet flights?</b><br />For domestic flights passengers can carry a 7kg cabin bag along with a 15kg checked-in lggage. International baggage limits depend on route and ticket class but generally includes 10kg hand baggage and 25-35kg checked-in luggage.</li>
                            <li><b>How early should I reach the airport for a SpiceJet flight?</b><br />For domestic flights, no less than 2 hours before takeoff. In case of international flights, 3 hours before is preferred.</li>
                            <li><b>Can I reschedule my SpiceJet booking?</b><br />Yea, reservations can be changed either through SuperbWorldTrip or the official portal of SpiceJet.</li>
                            <li><b>Does SpiceJet allow pets on board?</b><br />Yes, SpiceJet allows pets (dogs and cats) to be carried in the cargo area under certain circumstances. Pets are not allowed in the cabin, except for service dogs.</li>
                        </ol>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default SpicejetFlightContents